import {
  EntityState,
  EntityStore,
  StoreConfig,
  ActiveState,
  QueryEntity,
} from '@datorama/akita';
import { Website } from '../types';
import produce from 'immer';

export interface WebsiteState
  extends EntityState<Website, string>,
    ActiveState {}

const createInitialState = (): WebsiteState => {
  return {
    active: null,
  };
};

@StoreConfig({ name: 'websites', producerFn: produce })
export class WebsiteStore extends EntityStore<WebsiteState, Website> {
  constructor() {
    super(createInitialState());
  }
}

export class WebsitesQuery extends QueryEntity<WebsiteState> {
  activeWebsite$ = this.selectActive();
  loading$ = this.selectLoading();
  websites$ = this.selectAll();

  constructor(protected store: WebsiteStore) {
    super(store);
  }
}

export const websitesStore = new WebsiteStore();
export const websitesQuery = new WebsitesQuery(websitesStore);
